const { documentReady } = require('@grpn/document-states');

function grouponExtended() {
  // get body classes
  const bodyClasses = document.body.classList;

  Object.assign(window.Groupon, {
    App: {
      name: document.head.dataset.app,
    },
    Browsers: {
      chrome: !!window.chrome,
      phantomJS: !!(window._phantom || window.callPhantom),
      safari:
        (navigator.vendor != null
          ? navigator.vendor.indexOf('Apple')
          : undefined) > -1 &&
        !(navigator.userAgent != null
          ? navigator.userAgent.match('CriOS')
          : undefined),
    },
    PageFlags: {
      isWeb: bodyClasses.contains('is-web'),
      isTouch: bodyClasses.contains('is-touch'),
      isLegacyResponsive: bodyClasses.contains('ls-resp'),
      isTouchRedesign: bodyClasses.contains('t-redesign'),
      isTouchRequest: bodyClasses.contains('is-touch-request'),
    },
  });
}

documentReady.then(() => {
  grouponExtended();
});
